import { useTranslation } from 'react-i18next';
import Input from 'src/components/FormComponents/Input';
import { EnvelopeIcon, PhoneIcon } from 'src/components/Icons/icons';
import { Contact, ContactKind } from './accessErrors';

type ContactInputProps = {
    contact: Contact;
    onChange: (contact: Contact) => void;
    /** Hides the email/phone switch when only one kind applies. */
    lockedKind?: boolean;
    label?: string;
    error?: string;
    disabled?: boolean;
};

/** Email or Norwegian mobile number, with a link to switch between them. */
export const ContactInput = ({
    contact,
    onChange,
    lockedKind,
    label,
    error,
    disabled,
}: ContactInputProps) => {
    const { t } = useTranslation();
    const isPhone = contact.kind === 'phone';
    const switchTo = (kind: ContactKind) => onChange({ kind, value: '' });

    return (
        <div className="flex flex-col gap-2">
            <Input
                className="text-input"
                label={
                    label ??
                    t(
                        isPhone
                            ? 'accountAccess.phoneLabel'
                            : 'accountAccess.emailLabel',
                    )
                }
                type={isPhone ? 'tel' : 'email'}
                inputMode={isPhone ? 'tel' : 'email'}
                autoComplete={isPhone ? 'tel' : 'email'}
                leadingIcon={isPhone ? PhoneIcon : EnvelopeIcon}
                value={contact.value}
                disabled={disabled}
                error={error ? { type: 'server', message: error } : undefined}
                onChange={event =>
                    onChange({ kind: contact.kind, value: event.target.value })
                }
            />
            {isPhone && (
                <p className="text-xs text-mongooseGray">
                    {t('accountAccess.phoneHint')}
                </p>
            )}
            {!lockedKind && (
                <button
                    type="button"
                    className="self-start text-sm underline underline-offset-2"
                    disabled={disabled}
                    onClick={() => switchTo(isPhone ? 'email' : 'phone')}
                >
                    {t(
                        isPhone
                            ? 'accountAccess.useEmail'
                            : 'accountAccess.usePhone',
                    )}
                </button>
            )}
        </div>
    );
};
